import { render, staticRenderFns } from "./CustomerCardLoadDialog.vue?vue&type=template&id=60694044"
import script from "./CustomerCardLoadDialog.vue?vue&type=script&lang=js"
export * from "./CustomerCardLoadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports